import {
  SEND_EMAILS_START,
  SEND_EMAILS_ERROR,
  SEND_EMAILS_SUCCESS,
} from 'constants/action-types/communication/sendEmails';

export default (state, { type, payload }) => {
  switch (type) {
    case SEND_EMAILS_START:
      return {
        ...state,
        emails: {
          ...state.emails,
          loading: true,
          error: null,
        },
      };
    case SEND_EMAILS_ERROR:
      return {
        ...state,
        emails: {
          ...state.emails,
          error: payload,
          loading: false,
        },
      };
    case SEND_EMAILS_SUCCESS:
      return {
        ...state,
        emails: {
          ...state.emails,
          message: payload,
          loading: false,
        },
      };
    default:
      return null;
  }
};
